export default
{
    "krita.add": "Bæta við",
    "krita.amount": "Upphæð",
    "krita.application.adminoffer": "Offer admin",
    "krita.application.amountsonapp": "Upphæðir",
    "krita.application.application": "Umsókn",
    "krita.application.approve": "Samþykkja",
    "krita.application.approveapplication": "Samþykkja fjármögnun?",
    "krita.application.buffer": "Ófjármagnað og haldið eftir",
    "krita.application.cancelapplication": "Fella niður",
    "krita.application.capital": "Höfuðstóll",
    "krita.application.claimaccountnumber": "Kröfunúmer",
    "krita.application.claimant": "Lántakandi",
    "krita.application.claimsinapp": "Kröfur í umsókn",
    "krita.application.dateoffer": "Tilboð gert",
    "krita.application.duedate": "Gjalddagi",
    "krita.application.factoringduedate": "Gjalddagi fjármögnunar",
    "krita.application.feeamount": "Kostnaður",
    "krita.application.initafterref": "Millfært út",
    "krita.application.initialtransfer": "Upphæð fjármögnunar",
    "krita.application.initwithoutrefres": "Greitt út",
    "krita.application.modal.cancel": "Hafna",
    "krita.application.modal.remove": "Fjarlægja",
    "krita.application.modal.removetext": "Með því að fjarlægja kröfu úr umsókn mun umsóknin fara í endurmat. Ertu viss um að þú viljir halda áfram?",
    "krita.application.modal.text": "Ertu viss um að þú viljir fella niður umsóknina?",
    "krita.application.originalcapital": "Höfuðstóll",
    "krita.application.refactored": "Endurfjármagnað",
    "krita.application.registryid": "Kennitala",
    "krita.application.reservedforref": "Frátekið í endurfjármögnun",
    "krita.application.status.canceled": "Niðurfellt",
    "krita.application.status.completed": "Samþykkt",
    "krita.application.status.new": "Í umsóknarferli",
    "krita.application.status.pending": "Bíður þinnar samþykktar",
    "krita.application.status.processing": "Í vinnslu",
    "krita.application.totalofferamount": "Tilboðsupphæð",
    "krita.applicationdetail": "Umsókn",
    "krita.applicationdetail.header.home": "Umsókn",
    "krita.bankclaim.status.canceled": "Niðurfelld",
    "krita.bankclaim.status.legalcollection": "Löginnheimta",
    "krita.bankclaim.status.paid": "Greidd",
    "krita.bankclaim.status.returned": "Skilað",
    "krita.bankclaim.status.secondarycollection": "Milliinnheimta",
    "krita.bankclaim.status.unpaid": "Ógreidd",
    "krita.cancel": "Hætta við",
    "krita.claims.add": "Bæta við",
    "krita.claims.additems": " valin, að andvirði",
    "krita.claims.all": "Allt",
    "krita.claims.applicationsinprogress": "Umsóknir í vinnslu",
    "krita.claims.availableclaims": "Virkar kröfur",
    "krita.claims.capital": "Höfuðstóll",
    "krita.claims.clear": "Hreinsa",
    "krita.claims.createapplication": "Senda umsókn",
    "krita.claims.createrepayment": "Staðfesta",
    "krita.claims.debtornamekennitala": "Greiðandi",
    "krita.claims.duedate": "Gjalddagi",
    "krita.claims.factoredclaims": "Óuppgert",
    "krita.claims.factoringduedate": "Gjalddagi fjármögnunar",
    "krita.claims.faktor": "Fjármagna",
    "krita.claims.faktorclaims": "Fjármagna kröfur",
    "krita.claims.faktormodal.part1": "Fjöldi krafna er ",
    "krita.claims.faktormodal.part2": "Samtala upphæðar þeirra er ",
    "krita.claims.faktormodal.part3": "Lengd fjármögnunar fyrir hverja og eina kröfu er til og með eindaga hennar. Þú færð  sendan tilkynningu með tölvupósti þegar tilboð liggur fyrir.",
    "krita.claims.finalduedate": "Eindagi",
    "krita.claims.header.home": "Kröfur",
    "krita.claims.id": "Nr",
    "krita.claims.items": "valin, að andvirði",
    "krita.claims.lefttopay": "Eftirstöðvar",
    "krita.claims.namekennitala": "Greiðandi",
    "krita.claims.nodata": "Engar færslur",
    "krita.claims.overdue": "Gjaldfallið",
    "krita.claims.overduefactorings": "Óuppgert",
    "krita.claims.pastduedate": "Gjaldfallið",
    "krita.claims.repay": "Endurgreiða",
    "krita.claims.repayfactoring": "Endurgreiða",
    "krita.claims.repaymodal.part1": "Endurgreiða ",
    "krita.claims.repaymodal.part2": " fjármögnun að upphæð ",
    "krita.claims.repaymodal.part3": "Stofnuð verður krafa í heimabanka sem skal greiða til að gera upp eftirstöðvar.",
    "krita.claims.soon": "Fellur bráðum",
    "krita.claims.status": "Staða",
    "krita.claims.total": "Samtals",
    "krita.claims.unfactoredclaims": "Virkar kröfur",
    "krita.close": "Loka",
    "krita.datepick.enddate": "Til",
    "krita.datepick.startdate": "Frá",
    "krita.factoring.account": "Kröfunúmer",
    "krita.factoring.alreadypaid": "Greidd upphæð",
    "krita.factoring.alreadypaidhelp": "Samtala allra greiðslna sem hefur verið ráðstafað inn á fjármögnunina",
    "krita.factoring.amountsonfac": "Upphæðir",
    "krita.factoring.applicationid": "Umsókn",
    "krita.factoring.bankclaiminfo": "Bankakrafa",
    "krita.factoring.batchid": "Bunki",
    "krita.factoring.bufferallocation": "Ráðstöfun tryggingar",
    "krita.factoring.capital": "Höfuðstóll",
    "krita.factoring.claimantname": "Lántakandi",
    "krita.factoring.claimantregistryid": "Kennitala",
    "krita.factoring.created": "Stofnað",
    "krita.factoring.currentbuffer": "Staða tryggingar",
    "krita.factoring.currentbufferhelp": "Upphæð sem haldið er eftir þar til uppgjör hefur átt sér stað.\t\n",
    "krita.factoring.date": "Dagsetning",
    "krita.factoring.debtorname": "Greiðandi",
    "krita.factoring.debtorregistryid": "Kennitala",
    "krita.factoring.duedate": "Gjalddagi",
    "krita.factoring.facduedate": "Gjalddagi fjármögnunar",
    "krita.factoring.feeamount": "Kostnaður",
    "krita.factoring.feehelp": "Kostnaðurinn við fjármögnunina",
    "krita.factoring.finalduedate": "Eindagi",
    "krita.factoring.generalinfo": "Upplýsingar",
    "krita.factoring.id": "Nr",
    "krita.factoring.identifier": "Auðkenni",
    "krita.factoring.initamounthelp": "Upphæðin sem greidd er út til lántakanda",
    "krita.factoring.initialamount": "Greitt út",
    "krita.factoring.matching": "Staðfest",
    "krita.factoring.offerdate": "Dagsetning tilboðs",
    "krita.factoring.originalcapital": "Upprunalegur höfuðstóll",
    "krita.factoring.paymentsource.querybank": "Kröfugreiðsla",
    "krita.factoring.paymentstofactoring": "Innborganir",
    "krita.factoring.payorregistryid": "Greiðandi",
    "krita.factoring.penaltyinterest": "Staða dagvaxta",
    "krita.factoring.penaltyinterestamount": "Dagvextir",
    "krita.factoring.penaltyinteresthelp": "Dagvextir reiknast á eftirstöðvar eftir gjalddaga fjármögnunar",
    "krita.factoring.remainingamount": "Eftirstöðvar",
    "krita.factoring.remainingamounthelp": "Staða viðskiptavinar vegna fjármögnunar\t",
    "krita.factoring.repaymentdate": "Uppgert",
    "krita.factoring.source": "Uppruni",
    "krita.factoring.status.alterfailed": "Villa",
    "krita.factoring.status.alterinit": "Í vinnslu",
    "krita.factoring.status.altersucceed": "Í vinnslu",
    "krita.factoring.status.canceled": "Niðurfellt",
    "krita.factoring.status.new": "Í vinnslu",
    "krita.factoring.status.pending": "Tilboð",
    "krita.factoring.status.repaid": "Uppgert",
    "krita.factoring.status.repaidduringprocess": "Í vinnslu",
    "krita.factoring.status.repaidoutofsystem": "Uppgert utan kerfis",
    "krita.factoring.status.unpaid": "Óuppgert",
    "krita.factoring.transfersout": "Uppgjör",
    "krita.factoring.transfertrigger": "Uppruni",
    "krita.factoring.underlyingamount": "Upphæð höfuðstóls þegar fjármögnun átti sér stað",
    "krita.factoringdetail": "Fjármögnun",
    "krita.factoringdetail.header.home": "Fjármögnun",
    "krita.faktoring": "Fjármögnun",
    "krita.home": "Heim",
    "krita.indicator.overdue": "Gjaldfallið",
    "krita.indicator.due": "Gjaldfellur í dag",
    "krita.indicator.soon": "Fellur bráðum",
    "krita.language": "Tungumál",
    "krita.language.english": "English",
    "krita.language.icelandic": "Íslenska",
    "krita.login.header": "Innskráning",
    "krita.login.label.password": "Lykilorð",
    "krita.login.label.user": "Notandanafn",
    "krita.login.lable.user": "Notandanafn",
    "krita.login.loginaction": "Innskrá",
    "krita.login.passtrough": "Vinsamlegast hinkrið",
    "krita.menu.claims": "Kröfur",
    "krita.menu.logout": "Útskrá",
    "krita.menu.reports": "Skýrslur",
    "krita.notification.factoringcreated": "Umsókn send",
    "krita.ok": "OK",
    "krita.remove": "Fjarlægja",
    "krita.reports.application.filter.all": "Allt",
    "krita.reports.application.filter.completed": "Lokið",
    "krita.reports.application.filter.inprogress": "Í vinnslu",
    "krita.reports.application.filter.labelcreated": "Stofnað",
    "krita.reports.application.header.capital": "Höfuðstóll",
    "krita.reports.application.header.created": "Stofnað",
    "krita.reports.application.header.id": "Nr",
    "krita.reports.application.header.initialtransferamount": "Útborgað",
    "krita.reports.application.header.numberofclaims": "Fjöldi",
    "krita.reports.application.header.status": "Staða",
    "krita.reports.applications": "Umsóknir",
    "krita.reports.factorings.filter.all": "Allt",
    "krita.reports.factorings.filter.labelcreated": "Stofnað",
    "krita.reports.factorings.filter.labeldue": "Gjalddagi fjármögnunar",
    "krita.reports.factorings.filter.pastduedate": "Gjaldfallið",
    "krita.reports.factorings.filter.repaid": "Uppgert",
    "krita.reports.factorings.filter.unpaid": "Óuppgert",
    "krita.reports.factorings.header.account": "Kröfunúmer",
    "krita.reports.factorings.header.account'": "Kröfunúmer",
    "krita.reports.factorings.header.capital": "Höfuðstóll",
    "krita.reports.factorings.header.created": "Stofnað",
    "krita.reports.factorings.header.debtorinfo": "Greiðandi",
    "krita.reports.factorings.header.debtorname": "Greiðandi",
    "krita.reports.factorings.header.debtorregistryid": "Kennitala",
    "krita.reports.factorings.header.factoringduedate": "Gjalddagi fjármögnunar",
    "krita.reports.factorings.header.id": "Nr",
    "krita.reports.factorings.header.initialtransferamount": "Upphæð greidd út",
    "krita.reports.factorings.header.lefttopay": "Óuppgert",
    "krita.reports.factorings.header.status": "Staða",
    "krita.reports.factorings.tabheader": "Uppgert",
    "krita.reports.header.home": "Skýrslur",
    "krita.status": "Staða",
    "krita.application.expirationdate": "Rennur út",
    "krita.datagrid.nodata": "Engar færslur",
    "krita.repayment.status.new": "Í vinnslu",
    "krita.repayment.bankclaiminfo": "Bankakrafa",
    "krita.reports.transfers.tabheader": "Millifærslur",
    "krita.reports.repayments.filter.new": "Í vinnslu",
    "krita.reports.repayments.filter.paid": "Greitt",
    "krita.reports.repayments.filter.canceled": "Niðurfellt",
    "krita.reports.repayments.filter.all": "Allt",
    "krita.reports.repayments.filter.legal": "Löginnheimta",
    "krita.reports.repayments.filter.repayment": "Endurgreiðslur",
    "krita.reports.repayments.header.id": "Id",
    "krita.reports.repayments.header.debtor": "Greiðandi",
    "krita.reports.repayments.header.factoringcount": "Fjöldi",
    "krita.reports.repayments.header.amount": "Upphæð",
    "krita.reports.repayments.header.type": "Tegund",
    "krita.reports.repayments.header.status": "Staða",
    "krita.reports.repayments.header.createdby": "Stofnað af",
    "krita.reports.repayments.header.expirationdate": "Rennur út",
    "krita.reports.repayments.header.created": "Stofnað",
    "krita.reports.repayments.tabheader": "Endurgreiðslur",
    "krita.reports.summaryreport.tabheader": "Samantekt",
    "krita.application.initialtransferamount": "Greitt út",
    "krita.notification.loginfailed": "Innskráning tókst ekki",
    "krita.notification.loginfailedgetuserinfo": "Ekki tókst að innskrá notanda.",
    "krita.factoring.paymentsource.refactoring": "Endurfjármagnað",
    "krita.factoring.paymentsource.repayment": "Endurgreiðsla",
    "krita.factoring.paymentsource.manual": "Handvirkt",
    "krita.factoring.paymentsource.inkassomanual": "Innheimtufélag handvirkt",
    "krita.reports.faktorings": "Fjármagnanir",
    "krita.repayment.amountsonrepayment": "Upphæðir",
    "krita.repayment.status.cancelled": "Niðurfellt",
    "krita.repayment.debtorname": "Greiðandi",
    "krita.repayment.debtorid": "Id",
    "krita.repayment.expirationdate": "Rennur út",
    "krita.repayment.created": "Stofnað",
    "krita.repayment.createdby": "Stofnað af",
    "krita.repayment.type": "Tegund",
    "krita.repayment.capital": "Höfuðstóll",
    "krita.repayment.currpenaltyinterest": "Dagvextir",
    "krita.repayment.total": "Samtals",
    "krita.repayment.debtorregistryid": "Kennitala",
    "krita.repayment.account": "Kröfunúmer",
    "krita.repayment.duedate": "Gjalddagi",
    "krita.repayment.finalduedate": "Eindagi",
    "krita.repayment.factorings": "Fjármagnanir",
    "krita.repayment.history": "Saga",
    "krita.repaymentdetail.history.header.status": "Staða",
    "krita.repaymentdetail.history.header.debtor": "Greiðandi",
    "krita.repaymentdetail.history.header.expirationdate": "Rennur út",
    "krita.repaymentdetail.history.header.capital": "Höfuðstóll",
    "krita.repaymentdetail.history.header.penaltyamount": "Dagvextir",
    "krita.repaymentdetail.history.header.modified": "Breytt",
    "krita.repaymentdetail.history.header.modifiedby": "Breytt af",
    "krita.repaymentdetail.history.header.action": "Aðgerð",
    "krita.repaymentdetail.factoring.header.id": "Id",
    "krita.repaymentdetail.factoring.header.debtor": "Greiðandi",
    "krita.repaymentdetail.factoring.header.status": "Staða",
    "krita.repaymentdetail.factoring.header.factoringduedate": "Gjalddagi fjármögnunar",
    "krita.repaymentdetail.factoring.header.capital": "Höfuðstóll",
    "krita.repaymentdetail.factoring.header.lefttopay": "Óuppgert",
    "krita.repaymentdetail.factoring.header.account": "Kröfunúmer",
    "krita.repaymentdetail.factoring.header.initialtransferamount": "Upphæð fjármögnunar",
    "krita.repaymentdetail.factoring.header.created": "Stofnað",
    "krita.action.insert": "Insert",
    "krita.action.update": "Update",
    "krita.repayment.type.repayment": "Endurgreiðsla",
    "krita.repayment.type.legal": "Löginnheimta",
    "krita.repaymentdetail.header.home": "Endurgreiðsla",
    "krita.transfers.all": "Allt",
    "krita.transfers.repayments": "Endurgreiðslur",
    "krita.transfers.applications": "Umsóknir",
    "krita.transfers.factorings": "Fjármagnanir",
    "krita.reports.transfers.header.reference": "Tilvísun",
    "krita.reports.transfers.header.amount": "Upphæð",
    "krita.reports.transfers.header.transferdate": "Dagsetning færslu",
    "krita.reports.transfers.header.type": "Tegund",
    "krita.reports.transfers.header.id": "Id",
    "krita.reports.transfers.header.created": "Stofnað",
    "krita.repayment.status.paid": "Greitt",
    "krita.login-remember": "Muna mig lengur",
    "krita.notification.repaymentcreated": "Endurgreiðsla stofnuð",
    "krita.application.removefactoring": "Fjarlægja fjármögnun úr umsókn",
    "krita.claims.header": "Kröfur",
    "krita.claims.repaymodal,part1": "Stofna endurgreiðslu fyrir ",
    "krita.datagrids.nodata": "Engar færslur",
    "krita.common.debtor": "Greiðandi",
    "krita.common.account": "Kröfunúmer",
    "krita.common.capital": "Höfuðstóll",
    "krita.common.dueDate": "Gjalddagi",
    "krita.common.finalDueDate": "Eindagi",
    "krita.common.status": "Staða",
    "krita.common.bankClaimInfo": "Bankakrafa",
    "krita.notification.error.getExcelSummaryReport": "Ekki tókst að ná í skýrslu. Reyndu aftur síðar.",
    "krita.factoring.duration": "Lengd fjármögnunar (dagar)",
    "krita.factoring.bufferAmount": "Tryggingarupphæð",
    "krita.factoring.apr": "APR",
    "krita.factoring.otherInfo": "aðrar upplýsingar",
    "krita.factoring.unpaidCapital": "Eftirstöðvar höfuðstóls",
    "krita.factoring.unpaidFee": "Eftirstöðvar þóknunar",
    "krita.common.id": "Nr",
    "krita.common.facDueDate": "Gjalddagi fjármögnunar",
    "krita.common.paymentDate": "Greiðsludagur",
    "krita.transfers.bankClaims": "bankakröfur",
    "krita.common.true": "satt",
    "krita.common.false": "rangt",
    "krita.common.all": "Allt",
    "krita.factoring.transferstatus.factoringbufferreturn": "Trygging fjármögnunar skilað",
    "krita.notification.error.unauthorized": "Ekki heimilað",
    "krita.notification.error.approveapplicationoffer": "Villa við að samþykkja umsókn",
    "krita.notification.approveapplicationoffer": "Umsókn samþykkt",
    "krita.notification.cancelapplicationoffer": "Hætta við tilboð",
    "krita.notification.error.cancelapplicationoffer": "Villa við að hætta við tilboð",
    "krita.notification.removesfactoringfromapplication": "Fjarlægja úr fjármögnun",
    "krita.notification.error.removesfactoringfromapplication": "Villa við að fjarlægja úr fjármögnun",
    "krita.indictator.due" : "Gjaldfallið",
}